/** 常量控制 */

// 字典表类型查询编码
export const sysDicType={
    vehicleType:'SYS_VEHICLE_TYPE',//车辆类型查询码
    driverType:'SYS_DRIVER_TYPE',//司机类型查询码
    driverState:'SYS_DRIVER_STATE',//司机状态查询码
}

// 管理员角色code，注意这是一个定值和数据库中管理员编码一致
export const roleAdminCode='admin'

